export default __webpack_public_path__ + "static/media/jsonlens.195c549f.png";